import {
  exchangeAgentGuidanceIdFormat,
  productFamilyIdFormat,
} from "@redotech/redo-ids-cockroach";
import { GuidanceSourceType } from "@redotech/redo-model/exchange-agent-guidance/guidance-source-type";
import * as z from "zod";

const productSummary = z.object({
  id: productFamilyIdFormat.schema,
  title: z.string(),
  imageUrl: z.string().nullable(),
});

const shopifyCollectionSummary = z.object({
  id: z.string(),
  name: z.string(),
  productsCount: z.number().optional(),
});

const guidanceSourceSchema = z.discriminatedUnion("type", [
  z.object({
    type: z.literal(GuidanceSourceType.PRODUCTS),
    products: z.array(productSummary),
  }),
  z.object({
    type: z.literal(GuidanceSourceType.SHOPIFY_COLLECTION),
    shopifyCollections: z.array(shopifyCollectionSummary),
  }),
]);

const recommendationSummary = z.object({
  context: z.string(),
  source: guidanceSourceSchema.optional(),
  products: z.array(productSummary),
});

export const listExchangeAgentGuidance = {
  name: "listExchangeAgentGuidance" as const,
  input: z.object({}),
  output: z.object({
    guidances: z.array(
      z.object({
        id: exchangeAgentGuidanceIdFormat.schema,
        name: z.string(),
        createdAt: z.string(),
        updatedAt: z.string(),
        /** @deprecated use source instead */
        returnProducts: z.array(productSummary),
        source: guidanceSourceSchema.optional(),
        recommendations: z.array(recommendationSummary),
      }),
    ),
  }),
};
